var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetadata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Meta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.727 3.636h6.637c.552 0 1 .447 1 1v6.637c0 .566-.212 1.06-.566 1.414L11.586 20.9a2.006 2.006 0 0 1-2.829 0l-5.656-5.657a2.006 2.006 0 0 1 0-2.829l8.212-8.212a1.974 1.974 0 0 1 1.414-.566zm-1.893 3.809c-.089 0-.168.065-.199.163L8.15 13.179a.569.569 0 0 0-.065.266c0 .276.19.5.423.5h2.115v4.25c0 .138.095.25.212.25.079 0 .152-.053.188-.136l2.505-5.613-.001-.001a.57.57 0 0 0 .058-.25c0-.277-.19-.5-.423-.5h-2.116v-4.25c0-.138-.095-.25-.211-.25zm6.47 1.08a1.5 1.5 0 1 0-2.124-2.121 1.5 1.5 0 0 0 2.123 2.121z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadata);
export default __webpack_public_path__ + "static/media/metadata.d58349e60bf200526f0f268db845d3f3.svg";
export { ForwardRef as ReactComponent };